module.exports = __webpack_public_path__ + "media/images/top/ranking-sample05-8cbac9a9dfbb03468d76ee84120be1f7.jpg";